// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1
// @Generated: 2022-09-21T17:34:06.086Z
//
// This file is generated. Do not edit this file!
import { pluginFactoryNoConfig } from 'bootstrap-vue/src/utils/plugins'
import {
  // BIconLandTech custom icons
  BIconLandTech,
  // LandTech icons
  BIconLtAdd,
  BIconLtAddOutline,
  BIconLtAlerts,
  BIconLtAllApps,
  BIconLtArrowDown,
  BIconLtArrowLeft,
  BIconLtArrowRight,
  BIconLtArrowUp,
  BIconLtBank,
  BIconLtBookmark,
  BIconLtCalendar,
  BIconLtChat,
  BIconLtChevronDown,
  BIconLtChevronUp,
  BIconLtClose,
  BIconLtCloseOutline,
  BIconLtCog,
  BIconLtComment,
  BIconLtCompanyTree,
  BIconLtDownload,
  BIconLtDrag,
  BIconLtFilters,
  BIconLtFullscreen,
  BIconLtHide,
  BIconLtImageAdd,
  BIconLtInformation,
  BIconLtLandinsightLogo,
  BIconLtLine,
  BIconLtListView,
  BIconLtMail,
  BIconLtMenu,
  BIconLtMinus,
  BIconLtMoreHorizontal,
  BIconLtMoreVertical,
  BIconLtNewTab,
  BIconLtPhone,
  BIconLtPolygon,
  BIconLtPrint,
  BIconLtQuestionmarkOutline,
  BIconLtRadius,
  BIconLtRuler,
  BIconLtSCurve,
  BIconLtSearch,
  BIconLtShieldKeyhole,
  BIconLtShow,
  BIconLtSixDots,
  BIconLtSortDown,
  BIconLtSortUp,
  BIconLtStageView,
  BIconLtStarFill,
  BIconLtTick,
  BIconLtTickOutline,
  BIconLtTime,
  BIconLtUploadCloud,
  BIconLtVideo,
  BIconLtWarning,
  BIconLtZoomToLocation
} from './landtech-icons'
// Icon component names for used in the docs
export const iconNames = [
  // LandTech icon component names
  'BIconLtAdd',
  'BIconLtAddOutline',
  'BIconLtAlerts',
  'BIconLtAllApps',
  'BIconLtArrowDown',
  'BIconLtArrowLeft',
  'BIconLtArrowRight',
  'BIconLtArrowUp',
  'BIconLtBank',
  'BIconLtBookmark',
  'BIconLtCalendar',
  'BIconLtChat',
  'BIconLtChevronDown',
  'BIconLtChevronUp',
  'BIconLtClose',
  'BIconLtCloseOutline',
  'BIconLtCog',
  'BIconLtComment',
  'BIconLtCompanyTree',
  'BIconLtDownload',
  'BIconLtDrag',
  'BIconLtFilters',
  'BIconLtFullscreen',
  'BIconLtHide',
  'BIconLtImageAdd',
  'BIconLtInformation',
  'BIconLtLandinsightLogo',
  'BIconLtLine',
  'BIconLtListView',
  'BIconLtMail',
  'BIconLtMenu',
  'BIconLtMinus',
  'BIconLtMoreHorizontal',
  'BIconLtMoreVertical',
  'BIconLtNewTab',
  'BIconLtPhone',
  'BIconLtPolygon',
  'BIconLtPrint',
  'BIconLtQuestionmarkOutline',
  'BIconLtRadius',
  'BIconLtRuler',
  'BIconLtSCurve',
  'BIconLtSearch',
  'BIconLtShieldKeyhole',
  'BIconLtShow',
  'BIconLtSixDots',
  'BIconLtSortDown',
  'BIconLtSortUp',
  'BIconLtStageView',
  'BIconLtStarFill',
  'BIconLtTick',
  'BIconLtTickOutline',
  'BIconLtTime',
  'BIconLtUploadCloud',
  'BIconLtVideo',
  'BIconLtWarning',
  'BIconLtZoomToLocation'
]
// Export the icons plugin
export const LandTechIconsPlugin = /*#__PURE__*/ pluginFactoryNoConfig({
  components: {
    // LandTech custom icon components
    BIconLandTech,
    // LandTech icon components
    BIconLtAdd,
    BIconLtAddOutline,
    BIconLtAlerts,
    BIconLtAllApps,
    BIconLtArrowDown,
    BIconLtArrowLeft,
    BIconLtArrowRight,
    BIconLtArrowUp,
    BIconLtBank,
    BIconLtBookmark,
    BIconLtCalendar,
    BIconLtChat,
    BIconLtChevronDown,
    BIconLtChevronUp,
    BIconLtClose,
    BIconLtCloseOutline,
    BIconLtCog,
    BIconLtComment,
    BIconLtCompanyTree,
    BIconLtDownload,
    BIconLtDrag,
    BIconLtFilters,
    BIconLtFullscreen,
    BIconLtHide,
    BIconLtImageAdd,
    BIconLtInformation,
    BIconLtLandinsightLogo,
    BIconLtLine,
    BIconLtListView,
    BIconLtMail,
    BIconLtMenu,
    BIconLtMinus,
    BIconLtMoreHorizontal,
    BIconLtMoreVertical,
    BIconLtNewTab,
    BIconLtPhone,
    BIconLtPolygon,
    BIconLtPrint,
    BIconLtQuestionmarkOutline,
    BIconLtRadius,
    BIconLtRuler,
    BIconLtSCurve,
    BIconLtSearch,
    BIconLtShieldKeyhole,
    BIconLtShow,
    BIconLtSixDots,
    BIconLtSortDown,
    BIconLtSortUp,
    BIconLtStageView,
    BIconLtStarFill,
    BIconLtTick,
    BIconLtTickOutline,
    BIconLtTime,
    BIconLtUploadCloud,
    BIconLtVideo,
    BIconLtWarning,
    BIconLtZoomToLocation
  }
})
// Export the LandTechIcons plugin installer
// Mainly for the stand-alone land-tech-icons.xxx.js builds
export const LandTechIcons = /*#__PURE__*/ pluginFactoryNoConfig(
  { plugins: { LandTechIconsPlugin } },
  { NAME: 'LandTechIcons' }
)
// --- END AUTO-GENERATED FILE ---
